export default "__VITE_ASSET__DcKUfKlj__"